<template>
  <b-modal
      id="update-courses-package-modal"
      title="Update Courses Package"
      size="lg"
      :ok-disabled="hasAlert"
      @ok="submit"
  >
    <div v-if="hasAlert" class="alert alert-warning" role="alert">
      Please input all fields
    </div>
    <label for="coursePackageName" class="col-form-label form-label">Name</label>
    <label class="sr-only" for="name-cn">Name(中文)</label>
    <div class="input-group input-group-md-vertical">
      <b-form-input
          type="text"
          class="form-control"
          placeholder="Name(中文)"
          :state="coursePackage.name.cn !== ''"
          :value="coursePackage.name.cn"
          v-on:input="value => input('name cn', value)"
      />
      <b-form-input
          type="text"
          class="form-control"
          placeholder="Name(中文)"
          :state="coursePackage.name.en !== ''"
          :value="coursePackage.name.en"
          v-on:input="value => input('name en', value)"
      />
    </div>
    <label for="courseDescription" class="col-form-label form-label">Description</label>
    <div class="input-group input-group-md-vertical">
      <b-form-textarea
          type="text"
          class="form-control"
          placeholder="Description(中文)"
          :state="coursePackage.description.cn !== ''"
          :value="coursePackage.description.cn"
          v-on:input="value => input('description cn', value)"
      />
      <b-form-textarea
          type="text"
          class="form-control"
          placeholder="Description(English)"
          :state="coursePackage.description.en !== ''"
          :value="coursePackage.description.en"
          v-on:input="value => input('description en', value)"
      />
    </div>
    <label for="amount" class="col-form-label form-label">Amount</label>
    <b-input-group prepend="$" append=".00" class="w-lg-50">
      <b-form-input
          id="amount"
          class="p-4"
          type="number"
          :value="coursePackage.amount"
          :state="coursePackage.amount !== ''"
          v-on:input="value => input('amount', value)"
      />
    </b-input-group>
    <label for="courses" class="col-form-label form-label">Paid & Free</label>
    <div class="input-group input-group-md-vertical">
      <b-form-input
          type="number"
          class="form-control"
          :value="coursePackage.paid"
          :state="coursePackage.paid !== ''"
          v-on:input="value => input('paid', value)"
      />
      <b-form-input
          type="number"
          class="form-control"
          :value="coursePackage.free"
          :state="coursePackage.free !== ''"
          v-on:input="value => input('free', value)"
      />
    </div>
    <label for="duration" class="col-form-label form-label">Duration</label>
    <b-input-group class="input-group input-group-sm-vertical w-lg-50">
      <b-form-input
          id="duration"
          type="number"
          :value="coursePackage.duration.duration"
          :state="coursePackage.duration.duration !== ''"
          v-on:input="value => input('duration', value)"
      />
      <template #append>
        <b-form-select
            class="form-select p-1"
            :options="membershipDurationOptions"
            :value="coursePackage.duration.duration_symbol"
            :state="coursePackage.duration.duration_symbol !== ''"
            v-on:input="value => input('duration_symbol', value)"
        />
      </template>
    </b-input-group>
    <label for="shared" class="col-form-label form-label">How many people gonna use this package ?</label>
    <b-form-input
        id="shared"
        type="number"
        class="w-50"
        :value="coursePackage.shared"
        :state="coursePackage.shared !== ''"
        v-on:input="value => input('shared', value)"
    />
  </b-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'update-courses-package-modal',
  data () {
    return {
      // options: [
      //   { value: 'year', text: 'Year(s)' },
      //   { value: 'month', text: 'Month(s)' },
      //   { value: 'week', text: 'Week(s)' },
      //   { value: 'day', text: 'Day(s)' },
      // ]
    }
  },
  props: {
    coursePackage: {
      type: Object,
      required: true,
      default: null
    }
  },
  computed: {
    ...mapState('product', ['membershipDurationOptions']),
    hasAlert () {
      return Object.values(this.coursePackage).some(item => {return item === ''})
    }
  },
  methods: {
    input(name, value) {
      this.$emit('update', {name, value})
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>